import React, { useEffect, useRef } from 'react';
import * as PDF417 from 'pdf417-generator';

type Props = {
  price: string;
  userFirstName: string;
  userLastName: string;
  userAddress: string;
  userCity: string;
  oib: string;
  recipient: string;
  recipientAddress: string;
  recipientCity: string;
  model: string;
  iban: string;
  description: string;
  callPrefix?: string;
  hidden: boolean;
  onBarcodeGenerated?: (canvas: HTMLCanvasElement) => void;
};

export const BarCode: React.FC<Props> = (props) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  const removeDiacritics = (item: string): string => {
    if (!item) return '';
    return item
      .replace(/š/g, 's').replace(/Š/g, 'S')
      .replace(/Č/g, 'C').replace(/č/g, 'c')
      .replace(/Ć/g, 'C').replace(/ć/g, 'c')
      .replace(/Đ/g, 'd').replace(/đ/g, 'd')
      .replace(/Ž/g, 'Z').replace(/ž/g, 'z');
  };

  useEffect(() => {
    const fullName = `${props.userFirstName} ${props.userLastName}`;
    let price = String(props.price).replace(/[ ,.]/g, '');
    while (price.length < 15) {
      price = `0${price}`;
    }

    const qrCode = `HRVHUB30
EUR
${price}
${removeDiacritics(fullName).toUpperCase()}
${removeDiacritics(props.userAddress).toUpperCase()}
${removeDiacritics(props.userCity).toUpperCase()}
${removeDiacritics(props.recipient).toUpperCase()}
${removeDiacritics(props.recipientAddress).toUpperCase()}
${removeDiacritics(props.recipientCity).toUpperCase()}
${props.iban}
${props.model}
${props.callPrefix ? props.callPrefix : ''}${props.oib !== '0' ? props.oib : 'Vas oib'}
COST
${removeDiacritics(props.description)}`;

    if (canvasRef.current) {
      PDF417.draw(qrCode, canvasRef.current);
      if (props.onBarcodeGenerated) {
        props.onBarcodeGenerated(canvasRef.current);
      }
    }
  }, [props]);

  return (
    <canvas
      ref={canvasRef}
      width="250px"
      height="100px"
      style={{
        display: props.hidden ? 'none' : 'block',
        width: '250px',
        height: '100px',
      }}
    />
  );
};
